// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function emptyModel(param) {
  return {
          id: undefined,
          name: "",
          active: false
        };
}

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function active(t) {
  return t.active;
}

function setId(t, id) {
  return {
          id: id,
          name: t.name,
          active: t.active
        };
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          active: t.active
        };
}

function setActive(t, active) {
  return {
          id: t.id,
          name: t.name,
          active: active
        };
}

function decodeModels(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          active: Json_decode.field("active", Json_decode.bool, json)
        };
}

function encodeModel(m) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), m.id)
              ],
              tl: {
                hd: [
                  "name",
                  m.name
                ],
                tl: {
                  hd: [
                    "active",
                    m.active
                  ],
                  tl: /* [] */0
                }
              }
            });
}

exports.id = id;
exports.name = name;
exports.active = active;
exports.emptyModel = emptyModel;
exports.decodeModels = decodeModels;
exports.encodeModel = encodeModel;
exports.setId = setId;
exports.setName = setName;
exports.setActive = setActive;
/* No side effect */
